import { render, staticRenderFns } from "./StatementsUpdatePage.vue?vue&type=template&id=575a3e71&scoped=true&"
import script from "./StatementsUpdatePage.vue?vue&type=script&lang=ts&"
export * from "./StatementsUpdatePage.vue?vue&type=script&lang=ts&"
import style0 from "./StatementsUpdatePage.vue?vue&type=style&index=0&id=575a3e71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575a3e71",
  null
  
)

export default component.exports